export default {
  nav: { home: "Accueil", treatments: "Soins", about: "À propos", studio: "Studio", contact: "Contact" },
  cta: {
    book: "Prendre rendez-vous",
    discover: "Découvrir les soins",
    moreAbout: "En savoir plus sur moi",
    allTreatments: "Tous les soins",
    send: "Envoyer la demande",
    sending: "Envoi en cours…",
    call: "Appeler maintenant",
    whatsapp: "Écrire sur WhatsApp",
    backHome: "Retour à l'accueil",
    discoverStudio: "Découvrir le studio",
    request: "Demander un rendez-vous",
    readMore: "En savoir plus",
  },
  header: { openMenu: "Ouvrir le menu", closeMenu: "Fermer le menu", languageLabel: "Choisir la langue" },
  home: {
    heroEyebrow: "Beauty & Wellness · Bâle",
    heroLines: ["Beauté.", "Détente.", "Bien-être."],
    heroWelcomePre: "Bienvenue chez",
    heroWelcomeBrand: "IMPERIUM.",
    heroSub: "Cosmétique professionnelle et massages bienfaisants pour plus d'éclat, de calme et de bien-être.",
    heroQuote: "« Accompagnement personnel, soins de haute qualité et une atmosphère dans laquelle vous vous retrouvez pleinement. »",
    trustNo: "01",
    trustEyebrow: "Confiance",
    trustTitle: "La beauté commence par la confiance.",
    trustText: "Votre peau, votre corps et votre bien-être méritent toute notre attention. Chez IMPERIUM, soin professionnel, conseil personnalisé et atmosphère apaisante se rencontrent pour que vous vous sentiez parfaitement à votre place.",
    trustPoints: ["Accompagnement personnel", "Soin individuel", "Atmosphère raffinée", "Cosmétique professionnelle", "Du temps pour vos besoins"],
    servicesNo: "02",
    servicesEyebrow: "Soins",
    servicesTitle: "Qu'aimeriez-vous placer au centre aujourd'hui ?",
    servicesIntro: "Massages, cosmétique et styling – chaque soin est adapté individuellement à vos besoins.",
    auszeitNo: "03",
    auszeitEyebrow: "Votre parenthèse",
    auszeitTitle: "Votre parenthèse commence à l'instant où vous vous choisissez.",
    auszeitText: "Laissez le quotidien derrière vous pour un moment. Ressentez le calme, le soin et une énergie nouvelle – adaptés à vous.",
    ablaufEyebrow: "Déroulement",
    ablaufTitle: "Votre moment Imperium commence simplement",
    steps: [
      { t: "Choisir le soin", d: "Vous découvrez ce qui vous ferait du bien aujourd'hui." },
      { t: "Prendre contact", d: "Très simplement, par formulaire, WhatsApp ou téléphone." },
      { t: "Être conseillée personnellement", d: "Tout est adapté à vous et à vos envies." },
      { t: "Arriver détendue", d: "Vous entrez et le quotidien reste dehors." },
      { t: "Profiter du soin", d: "Votre moment Imperium – rien que pour vous." },
    ],
    expertNo: "04",
    expertEyebrow: "Votre experte",
    expertName: "Leidiane Alcântara",
    expertText: "Professionnelle de l'esthétique et du bien-être – avec dévouement, formation continue et un regard attentif aux besoins individuels de chaque personne.",
    studioNo: "05",
    studioEyebrow: "Le studio",
    studioTitle: "Un lieu qui naît avec amour du détail.",
    studioText: "À Bâle naît IMPERIUM Beauty & Wellness – un studio moderne, élégant et confortable, créé pour une expérience complète de beauté, de soin et de bien-être.",
    galleryEyebrow: "Galerie",
    galleryTitle: "Aperçus de l'univers IMPERIUM",
    finalTitle: "Prête pour votre plus belle parenthèse ?",
    finalText: "Prenez du temps pour vous. Je me réjouis de faire votre connaissance.",
    marquee: ["Esthétique", "Massages", "Drainage lymphatique", "Soins du visage", "Maquillage", "Bien-être"],
  },
  treatmentsPage: {
    eyebrow: "Soins",
    title: "Vos soins chez IMPERIUM",
    intro: "Massages, cosmétique et styling – découvrez ce qui vous ferait du bien aujourd'hui. Chaque soin est adapté individuellement à vous.",
    massage: "Massages & Corps",
    beauty: "Cosmétique & Styling",
  },
  treatment: {
    back: "Tous les soins",
    related: "Autres soins",
    ctaTitle: "Demander ce soin",
    ctaText: "Parlez-moi de vos envies – je vous conseille personnellement et nous trouverons ensemble votre moment Imperium.",
  },
  about: {
    eyebrow: "À propos",
    title: "Leidiane Alcântara",
    role: "Esthétique & Bien-être",
    bio: [
      "Je suis Leidiane Alcântara, professionnelle de l'esthétique et du bien-être – passionnée par l'art de prendre soin des personnes et de révéler ce qu'il y a de plus beau en chacune d'elles.",
      "Avec dévouement, une formation continue et un regard attentif aux besoins individuels, j'ai construit mon parcours avec beaucoup de travail, de responsabilité et d'amour pour ce que je fais.",
      "Je crois que chaque personne est unique. C'est pourquoi j'offre un accompagnement personnalisé, avec des techniques modernes et sûres – en plaçant toujours le soin, l'esthétique et le bien-être au premier plan.",
    ],
    storyEyebrow: "L'histoire",
    storyTitle: "Le rêve d'IMPERIUM",
    story: [
      "Aujourd'hui, je réalise un grand rêve : j'ouvre IMPERIUM Beauty & Wellness – un magnifique studio, créé spécialement pour offrir une expérience complète de beauté, de soin et de bien-être.",
      "Chaque détail est préparé avec beaucoup d'amour, afin que chaque cliente se sente accueillie, valorisée et vive un moment unique, dans un cadre moderne, élégant et confortable.",
      "Ce sera un lieu où l'esthétique, la relaxation et l'estime de soi se rencontrent – parce que prendre soin de vous est ma plus grande mission.",
    ],
    quote: "« Prendre soin de vous est ma plus grande mission. »",
    philosophyEyebrow: "Philosophie",
    philosophyTitle: "Chaque personne est unique.",
    philosophyText: "Accompagnement personnel, techniques modernes et sûres – toujours avec le soin, l'esthétique et le bien-être pour priorité.",
    ctaTitle: "Faisons connaissance.",
    ctaText: "Je me réjouis de votre message – personnel, simple et sans engagement.",
  },
  studio: {
    eyebrow: "Studio",
    title: "IMPERIUM à Bâle",
    intro: "Un studio créé pour la beauté, le soin et le bien-être – moderne, élégant et confortable.",
    preparing: "Le studio est actuellement préparé avec beaucoup d'amour du détail. Chaque recoin est pensé pour que vous vous sentiez accueillie et valorisée dès le premier instant.",
    locationLabel: "Lieu",
    location: "Austrasse 31, 4051 Basel, Switzerland",
    ctaTitle: "Soyez là dès le début.",
    ctaText: "Écrivez-moi – je me réjouis de vous lire.",
  },
  contact: {
    eyebrow: "Contact",
    title: "Votre moment Imperium commence ici.",
    intro: "Question, envie ou rendez-vous – écrivez-moi. Je vous réponds personnellement.",
    locationLabel: "Lieu",
    phoneLabel: "Téléphone & WhatsApp",
    emailLabel: "E-mail",
    instagramLabel: "Instagram",
    formTitle: "Envoyer une demande",
  },
  form: {
    name: "Prénom & nom",
    email: "E-mail",
    phone: "Téléphone (facultatif)",
    treatment: "Soin",
    treatmentPlaceholder: "Choisir un soin",
    noPreference: "Pas encore sûre / Conseil",
    message: "Message",
    messagePlaceholder: "Comment puis-je vous aider ?",
    privacy: "J'ai lu la politique de confidentialité et j'accepte le traitement de mes données pour répondre à ma demande.",
    submit: "Envoyer la demande",
    sending: "Envoi en cours…",
    success: "Merci beaucoup ! Votre demande est bien arrivée. Je vous répondrai personnellement dès que possible.",
    error: "Une erreur est survenue. Veuillez réessayer ou m'écrire sur WhatsApp.",
    required: "Veuillez remplir tous les champs obligatoires.",
    invalidEmail: "Veuillez saisir une adresse e-mail valide.",
    privacyRequired: "Veuillez confirmer la politique de confidentialité.",
  },
  footer: {
    tagline: "Esthétique · Massages · Bien-être",
    navTitle: "Navigation",
    treatmentsTitle: "Soins",
    contactTitle: "Contact",
    legalTitle: "Mentions légales",
    impressum: "Impressum",
    privacy: "Confidentialité",
    rights: "Tous droits réservés.",
    location: "Austrasse 31, 4051 Basel, Switzerland",
  },
  impressum: {
    title: "Impressum",
    operatorLabel: "Exploitante",
    operator: "IMPERIUM Beauty & Wellness — Leidiane Alcântara",
    contactLabel: "Contact",
    contentLabel: "Responsable du contenu",
    note: "Les mentions légales complémentaires sont en cours de complétion et seront bientôt ajoutées.",
  },
  privacyPage: {
    title: "Politique de confidentialité",
    responsibleTitle: "Responsable",
    responsibleText: "IMPERIUM Beauty & Wellness — Leidiane Alcântara, Austrasse 31, 4051 Basel, Switzerland.",
    dataTitle: "Données du formulaire de contact",
    dataText: "Lorsque vous m'écrivez via le formulaire, vos données (nom, e-mail, téléphone, message) sont utilisées exclusivement pour répondre à votre demande et ne sont pas transmises à des tiers.",
    storageTitle: "Stockage dans le navigateur",
    storageText: "Ce site enregistre uniquement votre choix de langue et votre décision concernant les cookies, localement dans votre navigateur. Aucun cookie de suivi n'est utilisé.",
    rightsTitle: "Vos droits",
    rightsText: "Vous disposez à tout moment d'un droit d'accès, de rectification ou de suppression de vos données. Écrivez simplement à kontakt@imperium-wellness.ch.",
  },
  google: { label: "IMPERIUM sur Google", rate: "Évaluer sur Google", reviews: "Voir les avis" },
  notfound: {
    title: "404",
    heading: "Cette page est introuvable.",
    text: "Vous trouverez peut-être ici ce que vous cherchez :",
  },
  cookie: {
    text: "Ce site utilise uniquement un stockage techniquement nécessaire – par exemple pour votre choix de langue. Aucun cookie de suivi n'est déposé.",
    accept: "Compris",
    more: "Confidentialité",
  },
  seo: {
    homeTitle: "IMPERIUM Beauty & Wellness | Cosmétique, Esthétique & Massages à Bâle",
    homeDesc: "Cosmétique professionnelle et massages bienfaisants pour plus d'éclat, de calme et de bien-être. Votre beauté. Votre moment. Votre Imperium.",
  },
};
